import { fetchPage } from "../useFetch";

export const pageFilter = (data, pageTitle) => {
  const content = data.items.map((d) => {
    if (d.title === pageTitle) {
      return d;
    }
  });

  const filtered = content.filter((x) => {
    if (x !== undefined) {
      return x;
    }
  });

  return filtered;
};

export const fetchPageData = async (pageType, pageTitle) => {
  const fetchWagtail = await fetchPage(pageType);

  let pageData;
  if (fetchWagtail.status === 200) {
    const pageTemp = await fetchWagtail.json();
    pageData = await pageFilter(pageTemp, pageTitle);
  }

  return pageData;
};
